export const ENGLISH_CATEGORY_BLUEPRINTS = {
    phone: [
        {
            title: "GENERAL CHARACTERISTICS",
            items: [
                { label: "Phone Type", value: "" },
                { label: "SIM Slots", value: "" },
                { label: "SIM Type", value: "" },
                { label: "Operating System", value: "" },
                { label: "OS Version", value: "" },
                { label: "Connectivity", value: "" },
                { label: "Bluetooth Version", value: "" },
                { label: "Processor Model", value: "" },
                { label: "Number of Cores", value: "" },
                { label: "Sensors", value: "" },
                { label: "Package Contents", value: "" },
                { label: "Color", value: "" },
                { label: "Dimensions", value: "" },
                { label: "Weight", value: "" },
                { label: "Release Year", value: "" },
                { label: "Network Technology", value: "" },
                { label: "Protection Rating", value: "" }
            ]
        },
        {
            title: "DISPLAY",
            items: [
                { label: "Screen Size", value: "" },
                { label: "Display Type", value: "" },
                { label: "Resolution", value: "" },
                { label: "Display Features", value: "" }
            ]
        },
        {
            title: "MEMORY",
            items: [
                { label: "Internal Storage", value: "" },
                { label: "RAM Memory", value: "" }
            ]
        },
        {
            title: "CAMERA",
            items: [
                { label: "Number of Cameras", value: "" },
                { label: "Main Camera Resolution", value: "" },
                { label: "Front Camera Resolution", value: "" },
                { label: "Video Resolution", value: "" },
                { label: "Camera Features", value: "" },
                { label: "Flash", value: "" }
            ]
        },
        {
            title: "BATTERY & POWER",
            items: [
                { label: "Charger Included", value: "" },
                { label: "Battery Type", value: "" }
            ]
        }
    ],

    laptop: [
        {
            title: "GENERAL CHARACTERISTICS",
            items: [
                { label: "Product Line", value: "" },
                { label: "Model", value: "" },
                { label: "Color", value: "" },
                { label: "Battery Life", value: "" },
                { label: "Battery Capacity", value: "" },
                { label: "Dimensions (W x H x D)", value: "" },
                { label: "Weight", value: "" },
                { label: "Material", value: "" },
                { label: "Security", value: "" },
                { label: "Keyboard Layout", value: "" },
                { label: "Numeric Keypad", value: "" },
                { label: "Included Accessories", value: "" },
                { label: "Key Features", value: "" }
            ]
        },
        {
            title: "PROCESSOR",
            items: [
                { label: "Processor Brand", value: "" },
                { label: "Processor Type", value: "" },
                { label: "Processor Model", value: "" },
                { label: "Core Count", value: "" }
            ]
        },
        {
            title: "DISPLAY",
            items: [
                { label: "Display Size", value: "" },
                { label: "Display Format", value: "" },
                { label: "Display Technology", value: "" },
                { label: "Brightness", value: "" },
                { label: "Touchscreen", value: "" },
                { label: "Resolution", value: "" }
            ]
        },
        {
            title: "MEMORY",
            items: [
                { label: "Memory Capacity", value: "" }
            ]
        },
        {
            title: "STORAGE",
            items: [
                { label: "Storage Type", value: "" },
                { label: "SSD Capacity", value: "" }
            ]
        },
        {
            title: "GRAPHICS",
            items: [
                { label: "Graphics Type", value: "" },
                { label: "Graphics Technologies", value: "" }
            ]
        },
        {
            title: "AUDIO & CAMERA",
            items: [
                { label: "Web Camera", value: "" },
                { label: "Audio System", value: "" },
                { label: "Audio Technologies", value: "" }
            ]
        },
        {
            title: "PORTS & CONNECTIVITY",
            items: [
                { label: "Ports", value: "" },
                { label: "Card Reader", value: "" },
                { label: "Wireless Standard", value: "" },
                { label: "Bluetooth Version", value: "" },
                { label: "Operating System", value: "" }
            ]
        }
    ],

    tablet: [
        {
            title: "GENERAL CHARACTERISTICS",
            items: [
                { label: "Line-up", value: "" },
                { label: "SIM Connectivity", value: "" },
                { label: "Operating System", value: "" },
                { label: "OS Version", value: "" },
                { label: "Wireless Technology", value: "" },
                { label: "Charger Included", value: "" },
                { label: "Energy Class", value: "" },
                { label: "Sensors", value: "" },
                { label: "Package Contents", value: "" },
                { label: "Color", value: "" },
                { label: "Dimensions", value: "" },
                { label: "Weight", value: "" },
                { label: "Material", value: "" }
            ]
        },
        {
            title: "PROCESSOR",
            items: [
                { label: "Processor Brand", value: "" },
                { label: "Processor Model", value: "" },
                { label: "Number of Cores", value: "" }
            ]
        },
        {
            title: "DISPLAY",
            items: [
                { label: "Display Technology", value: "" },
                { label: "Display Size", value: "" },
                { label: "Resolution", value: "" }
            ]
        },
        {
            title: "MEMORY & STORAGE",
            items: [
                { label: "Memory Capacity", value: "" },
                { label: "Storage Capacity", value: "" }
            ]
        },
        {
            title: "CONNECTIVITY",
            items: [
                { label: "Bluetooth Version", value: "" },
                { label: "Wireless Standard", value: "" },
                { label: "Ports", value: "" }
            ]
        },
        {
            title: "BATTERY",
            items: [
                { label: "Battery Type", value: "" },
                { label: "Battery Life", value: "" }
            ]
        },
        {
            title: "CAMERA",
            items: [
                { label: "Main Camera", value: "" },
                { label: "Front Camera", value: "" }
            ]
        }
    ],

    wearable: [
        {
            title: "GENERAL CHARACTERISTICS",
            items: [
                { label: "Series", value: "" },
                { label: "Case Size", value: "" },
                { label: "Case Thickness", value: "" },
                { label: "Style", value: "" },
                { label: "Compatible OS", value: "" },
                { label: "SIM Type", value: "" },
                { label: "Strap Material", value: "" },
                { label: "Strap Color", value: "" },
                { label: "Case Material", value: "" },
                { label: "Case Color", value: "" },
                { label: "Charger Included", value: "" },
                { label: "Connectivity", value: "" },
                { label: "Package Contents", value: "" },
                { label: "Weight", value: "" }
            ]
        },
        {
            title: "TECHNICAL SPECIFICATIONS",
            items: [
                { label: "Display Style", value: "" },
                { label: "Display Type", value: "" },
                { label: "Display Size", value: "" },
                { label: "Processor Type", value: "" },
                { label: "Storage Capacity", value: "" },
                { label: "Battery Life", value: "" },
                { label: "Charging Type", value: "" }
            ]
        },
        {
            title: "FEATURES & SENSORS",
            items: [
                { label: "Monitored Activities", value: "" },
                { label: "Smart Features", value: "" },
                { label: "Sensors", value: "" }
            ]
        }
    ],

    audio: [
        {
            title: "TECHNICAL CHARACTERISTICS",
            items: [
                { label: "Type", value: "" },
                { label: "Bluetooth", value: "" },
                { label: "Bluetooth Version", value: "" },
                { label: "Connectors", value: "" },
                { label: "Features", value: "" },
                { label: "Max Signal Range", value: "" }
            ]
        },
        {
            title: "GENERAL CHARACTERISTICS",
            items: [
                { label: "Package Contents", value: "" },
                { label: "Color", value: "" },
                { label: "Weight", value: "" }
            ]
        },
        {
            title: "EFFICIENCY & BATTERY",
            items: [
                { label: "Charger Included", value: "" },
                { label: "Battery Life", value: "" }
            ]
        }
    ]
};

export const parseSpecifications = (text) => {
    if (!text || typeof text !== 'string') return null;

    const trimmed = text.trim();
    if (!trimmed) return null;

    // Check if it's stored as JSON array
    if (trimmed.startsWith('[')) {
        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed) && parsed.length > 0) {
                // Filter out empty items
                return parsed.map(sec => ({
                    title: sec.title || "SPECIFICATIONS",
                    items: (sec.items || []).filter(item => item.label && item.value && item.value.trim() !== "")
                })).filter(sec => sec.items.length > 0);
            }
        } catch (e) {
            // Fall back to plain text parsing
        }
    }

    // Fallback parsing for legacy text format
    const rawLines = trimmed.split('\n').map(l => l.trim());
    if (rawLines.length === 0) return null;

    const sections = [];
    let currentSection = null;
    let hasParsedAnyPair = false;

    for (let i = 0; i < rawLines.length; i++) {
        const line = rawLines[i];
        if (!line) continue;

        if (line.toLowerCase() === 'specificatii' || line.toLowerCase() === 'specificații' || line.toLowerCase() === 'specifications') {
            continue;
        }

        let label = "";
        let value = "";

        if (line.includes('\t')) {
            const parts = line.split('\t');
            label = parts[0].trim();
            value = parts.slice(1).join('\t').trim();
        } else if (line.includes(': ')) {
            const idx = line.indexOf(': ');
            label = line.substring(0, idx).trim();
            value = line.substring(idx + 2).trim();
        }

        if (label && value) {
            hasParsedAnyPair = true;
            if (!currentSection) {
                currentSection = { title: "GENERAL CHARACTERISTICS", items: [] };
            }
            currentSection.items.push({ label, value });
        } else {
            if (currentSection && currentSection.items.length > 0) {
                sections.push(currentSection);
            }
            currentSection = { title: line.toUpperCase(), items: [] };
        }
    }

    if (currentSection && currentSection.items.length > 0) {
        sections.push(currentSection);
    }

    return hasParsedAnyPair ? sections : null;
};
